module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'manabi-jikosaiten': _vm.$store.getters['config/isManabi']
    },
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [(_vm.$store.getters['config/checkerOpenFlg']['jikosaiten'] === '0') ? [_vm._m(0)] : [(_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active dn-tabs-top"
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("「自己採点結果の取得」を押して、「ベネッセ・駿台 データネット」で提出した自己採点結果を登録しましょう。")]), _vm._v(" "), _c('div', {
    staticClass: "tar"
  }, [_c('dn-btn', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.getApiDataInit()
      }
    }
  }, [_vm._v("\n              自己採点結果の取得\n            ")])], 1), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoaded && !_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n            総合得点を計算する\n          ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n              あなたの総合得点は・・・・\n\n              "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n                /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    attrs: {
      "accent": "",
      "href": "./hantei/index.html"
    }
  }, [_vm._v("合格可能性判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー'))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__bar"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active"
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n                総合得点を計算する\n              ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n                  あなたの総合得点は・・・・\n\n                  "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n                    /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_success"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("取得に成功しました。"), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_noscore"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("成績がありませんでした。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_scoreerr"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("通信に失敗しました。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('dn-icon', {
    attrs: {
      "icon": "tri-down--lg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active dn-tabs__next"
  }, [_c('p', {
    staticClass: "mb10",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("次に、志望校を登録しましょう")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickBtnChecker('../bible/search/index.html')
      }
    }
  }, [_vm._v("STEP2 志望校の登録へ　＞＞")])], 1)], 1)]] : [_c('div', {
    staticClass: "tar"
  }, [(_vm.$store.getters['config/isManabi']) ? _c('dn-btn', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.getApiData()
      }
    }
  }, [_vm._v("\n        自己採点結果の取得\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n          総合得点を計算する\n        ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n            あなたの総合得点は・・・・\n\n            "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n              /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickBtnChecker('./hantei/index.html')
      }
    }
  }, [_vm._v("合格可能性判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー'))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_noscore"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("成績がありませんでした。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticStyle: {
      "margin-left": "7em"
    },
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs['dialog-alert_noscore'].hide($event)
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_scoreerr"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("通信に失敗しました。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticStyle: {
      "margin-left": "7em"
    },
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs['dialog-alert_scoreerr'].hide($event)
      }
    }
  }, [_vm._v("OK")])], 1)])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active",
    staticStyle: {
      "border-top": "1px solid #adc4cc"
    }
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("公開までしばらくお待ちください。"), _c('br'), _vm._v("\n            大学入学共通テストの解答を入力すると、自己採点結果を計算することができるツールです。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("登録した内容で志望校の合格可能性判定を入力できます。"), _c('br'), _vm._v("自己採点結果が取得できない場合は、手動で受験結果を入力し、登録してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dn-tabs__container"
  }, [_c('a', {
    staticClass: "dn-tabs__item",
    attrs: {
      "href": "../bible/mock/index.html"
    }
  }, [_vm._v("\n            進研模試 3年10月\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "dn-tabs__item dn-tabs__item--active",
    attrs: {
      "href": "./index.html"
    }
  }, [_vm._v("\n            自己採点\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bc902d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/jikosaiten/index/App.vue
// module id = 923
// module chunks = 3